import "../../design/contact.css";
import { Container } from "react-bootstrap";
import { useRef, useState } from "react";
import emailjs from '@emailjs/browser';

const serviceID = process.env.REACT_APP_SERVICE_ID;
const templateID = process.env.REACT_APP_TEMPLATE_ID;
const publicKey = process.env.REACT_APP_PUBLIC_KEY;

const defaultObject = {
    user_name: '',
    user_email: '',
    message: '',
};

export default function Contact() {
    const [formData, setFormData] = useState(defaultObject);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);
    const form = useRef();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const sendEmail = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatusMessage({ type: 'info', text: 'TRANSMITTING MESSAGE...' });

        emailjs
            .sendForm(serviceID, templateID, form.current, {
                publicKey: publicKey,
            })
            .then(
                () => {
                    setStatusMessage({ type: 'success', text: 'MESSAGE DISPATCHED SUCCESSFULLY.' });
                    setFormData(defaultObject);
                    setIsSubmitting(false);
                },
                (error) => {
                    console.error('Email error:', error.text);
                    setStatusMessage({ type: 'error', text: 'TRANSMISSION FAILED. PLEASE TRY AGAIN.' });
                    setIsSubmitting(false);
                },
            );
    };

    return (
        <section id="contact" className="contactSection">
            <Container>
                <div className="cyberSectionHeader">
                    <span className="sectionTag">COMMUNICATION_LINK</span>
                    <h2>GET IN <span className="gradientText">TOUCH</span></h2>
                </div>

                <div className="contactFormWrapper glass-panel">
                    <form ref={form} onSubmit={sendEmail} className="cyberForm">
                        <div className="contactInputSpace">
                            <div className="inputGroup">
                                <label className="inputLabel">SENDER_NAME</label>
                                <input
                                    className="contactInput"
                                    type="text"
                                    name="user_name"
                                    placeholder="John Doe"
                                    value={formData.user_name}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="inputGroup">
                                <label className="inputLabel">SENDER_EMAIL</label>
                                <input
                                    className="contactInput"
                                    type="email"
                                    name="user_email"
                                    placeholder="john@example.com"
                                    value={formData.user_email}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="inputGroup">
                            <label className="inputLabel">PAYLOAD_MESSAGE</label>
                            <textarea
                                className="contactTextarea"
                                name="message"
                                value={formData.message}
                                placeholder="State project specs or inquiry details..."
                                onChange={handleChange}
                                required
                                disabled={isSubmitting}
                            />
                        </div>

                        {statusMessage && (
                            <div className={`statusBanner ${statusMessage.type}`}>
                                {statusMessage.text}
                            </div>
                        )}

                        <div className="contactFormButtonSpace">
                            <button
                                type="submit"
                                className="contactSubmitBtn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "TRANSMITTING..." : "DISPATCH MESSAGE"}
                            </button>
                        </div>
                    </form>
                </div>
            </Container>
        </section>
    );
}